import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FooterSection from '../../components/sections/FooterSection';
import NotFound from "../NotFound";

/*

Начало контейнера должно состоять из двух колонок равной ширины:
- слева - квадратная без скруглений в рамке фотография человека
- справа - имя, фамилия; мини-флажок гражданства; ниже кнопка "связаться" (className uk-button-jai); 
под ней жирным какой именно офис у человека (допустим "Astana"), кнопка "показать на карте"

далее margin под этими колонками, и там уже на всю ширину контейнера: 
- биография (несколько <p> тегов)
- сепаратор
- должность <h4>
- описание должности
- сепаратор
- когда и где учился (из UIKit возьми какой нибудь блок с таблицей)

В конце FooterSection, как уже показано здесь. i18n ключи пока не делай, но сам i18n убирать не нужно. 
Источник данных - "/public/data/team.json". В качестве идентификатора, в строке браузера будет "/:id", хз как правильно описать. 

В конце, добавь MemberInfoPage в App.js с роутом "/team/:id" (или как там правильно).

*/

function MemberInfoPage(props) {
    const { id } = useParams();
    const { t } = useTranslation();
    const [member, setMember] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        fetch('/data/team.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                const memberData = data.find(m => m.id === id);
                if (memberData) {
                    setMember(memberData);
                } else {
                    setError(true);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Failed to fetch team member data:", error);
                setError(true);
                setLoading(false);
            });
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error || !member) {
        return <NotFound />;
    }

    return(
        <>
            <div className="uk-container uk-container-xsmall uk-margin-top uk-margin-large-bottom">
                <div className="uk-grid-large" data-uk-grid>
                    {/* Left Column: Photo */}
                    <div className="uk-width-1-2@s">
                        <div style={{ border: '1px solid #e5e5e5', padding: '5px' }}>
                            <img src={member.photo} alt={member.name} className="uk-width-1-1" style={{ aspectRatio: '1 / 1', objectFit: 'cover' }} />
                        </div>
                    </div>

                    {/* Right Column: Info */}
                    <div className="uk-width-1-2@s">
                        <h2>{member.name} <span className={`fi fi-${member.citizenship_flag_icon}`}></span></h2>
                        <button className="uk-button uk-button-jai uk-margin-small-bottom">Связаться</button>
                        <p className="uk-margin-remove">
                            <strong>Офис:</strong> {member.office}
                        </p>
                        <Link to="/map" className="uk-button uk-button-text">Показать на карте</Link>
                    </div>
                </div>

                <div className="uk-margin-large-top">
                    <h3>Биография</h3>
                    {member.bio.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}

                    <hr className="uk-divider-icon" />

                    <h4>{member.role}</h4>
                    <p>{member.role_description}</p>

                    <hr className="uk-divider-icon" />

                    <h3>Образование</h3>
                    <div className="uk-overflow-auto">
                        <table className="uk-table uk-table-striped uk-table-hover">
                            <thead>
                                <tr>
                                    <th>Учебное заведение</th>
                                    <th>Специальность</th>
                                    <th>Годы обучения</th>
                                </tr>
                            </thead>
                            <tbody>
                                {member.education.map((edu, index) => (
                                    <tr key={index}>
                                        <td>{edu.institution}</td>
                                        <td>{edu.specialty}</td>
                                        <td>{edu.years}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            <FooterSection />
        </>
    );
}

export default MemberInfoPage;